module.exports = __webpack_public_path__ + "img/6.8143dde9.png";